<template>
	<div>
		<section>
			<div>
		      <div class="row collapse">
		        <label class="strong" for="classPrice">How much do you want to receive?</label>
		        <div class="small-3 columns">
		          <span class="prefix">{{symbol}}</span>
		        </div>
		        <div class="small-9 columns">
		          <input type="number" id="classPrice" name="classPrice" v-model.number="classPrice">
		        </div>
		      </div>
			</div>

<!-- 			<div>
		      <div class="row collapse">
		        <label class="strong" for="percent">Platform Fee Percentage</label>
		        <div class="small-9 columns">
		          <input type="number" id="percent" name="percent" v-model.number="percent">
		        </div>
		        <div class="small-3 columns">
		          <span class="postfix">%</span>
		        </div>
		      </div>
			</div> -->

<!-- 			<div>
		      <div class="row collapse">
		        <label class="strong" for="fixed">Fixed Fee</label>
		        <div class="small-9 columns">
		          <input type="number" id="fixed" name="fixed" v-model.number="fixed">
		        </div>
		        <div class="small-3 columns">
		          <span class="postfix">p</span>
		        </div>
		      </div>				
			</div> -->

<!-- 			<div>
				<label class="strong" for="bookingCount">Bookings</label>
				<input type="number" id="bookingCount" name="bookingCount" v-model.number="bookingCount">
			</div> -->

<!-- 			<div>
				<label class="strong" for="passOnTotal">Cost if you pass on to parents</label>
				<h5>{{symbol}}{{passOnTotal}}</h5>
			</div> -->


			<div>
				<label class="strong" for="absorbTotal">You should charge</label>
				<h4>{{symbol}}{{absorbTotal}}</h4>

<!-- 				<label class="strong" for="increase">Cost of processing for ClassForKids </label>
				<h4>{{symbol}}{{(absorbTotal - classPrice).toFixed(2)}}</h4> -->

			</div>


			<div v-if="absorbTotal != absorbTotalRounded" >
				<label class="strong" for="absorbTotalRoundedUp">Or round it up to</label>
				<h4>{{symbol}}{{absorbTotalRounded}}</h4>

			</div>

			<div v-if="potentialIncrease > 0">
				<label class="strong" for="potentialIncrease">and even make</label>
				<h4 class="mbn">{{symbol}}{{potentialIncrease}}</h4>
				<label class="strong" for="potentialIncrease">per booking</label>

<!-- 				<label class="strong" for="extra">Like having X extra bookings</label>
				<h5>{{parseInt(potentialIncrease / classPrice)}}</h5> -->

			</div>





			

		</section>
		
	</div>
</template>


<script>
'use strict';
	export default {
		name: 'SalesCalculatorCustomer',
		data() {
			return {
				classPrice: 50,
				bookingCount: 1
			}
		},

		props : {
			percent: {
				required: false,
				type: Number,
				default: function() {
					return parseFloat(this.$root.$el.dataset.commisionPercent);
				}
			},

			stripePercent : {
				required: false,
				type: Number,
				default: function() {
					return parseFloat(this.$root.$el.dataset.commisionStripePercent);
				}
			},

			fixed: {
				required: false,
				type: String,
				default: function() {
					return this.$root.$el.dataset.fixedFee;
				}
			},
			symbol: {
				required: false,
				type: String,
				default: function() {
					return this.$root.$el.dataset.currencySymbol
				}				
			},
		},


		methods: {
		
		},

		computed: {

			totalPercent() {
				return this.stripePercent + this.percent;
			},

			increase() {
				return (this.totalPercent / 100) * this.classPrice;
			},

			increaseWithFixed() {
				return this.increase + (this.fixed / 100);
			},

			passOnTotal() {
				return (this.classPrice + this.increaseWithFixed).toFixed(2);
			},

			absorbTotal() {
				return ( (this.classPrice + (this.fixed / 100)) / (1 - this.totalPercent / 100) ).toFixed(2);
			},

			absorbTotalRounded() {
				return Math.ceil(this.absorbTotal);
			},

			potentialIncrease() {
				return ((this.absorbTotalRounded - this.absorbTotal) * this.bookingCount).toFixed(2);
			}

		},

		components: {

		},

		beforeMount() {

		},

		mounted() {},
		created() {

		}

	}	
</script>



<style scoped>

section {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	grid-gap: 16px;
}


label {
	font-size: 0.8rem;
}
</style>